import styled from '@emotion/styled';

export const OverlayActions = styled('div')`
  position: absolute;
  right: 0.8em;
  top: 0.8em;
`;
